(function () {
	if (window.__kcSearchReady) return;
	window.__kcSearchReady = true;

	// --- Cross-panel coordination -------------------------------------------------
	// Only one of {search panel, currency panel, mega menu} may be open at a
	// time. Each panel announces itself on open via this event; every panel
	// (including the mega menu, see kc-mega-menu.js) listens and closes
	// itself unless it's the one that just opened.
	function announceOpen(name) {
		document.dispatchEvent(new CustomEvent('kc:panel:opened', { detail: { name: name } }));
	}

	// Shared, reference-counted header "solidify" state. Both this file and
	// kc-mega-menu.js call this instead of touching the header-section class
	// directly - two panels can briefly overlap during a hand-off (one
	// panel's close, triggered by the other's `kc:panel:opened`, can run
	// *after* the new panel already marked itself open), so a plain
	// add/remove from either side can clobber the other's state. Whichever
	// file loads first defines it.
	window.__kcOpenPanels = window.__kcOpenPanels || {};
	window.__kcSetHeaderSolid = window.__kcSetHeaderSolid || function (name, isOpen) {
		window.__kcOpenPanels[name] = isOpen;
		var headerSection = document.querySelector('.header-section');
		if (!headerSection) return;
		var anyOpen = Object.keys(window.__kcOpenPanels).some(function (key) {
			return window.__kcOpenPanels[key];
		});
		headerSection.classList.toggle('mega-menu-active', anyOpen);
	};

	// --- Search panel ---------------------------------------------------------------
	var searchToggles = Array.prototype.slice.call(document.querySelectorAll('[data-kc-search-toggle]'));
	var searchLastToggle = null;
	var searchPanel = document.querySelector('[data-kc-search-panel]');
	var searchOverlay = document.querySelector('[data-kc-search-overlay]');
	var searchInput = document.querySelector('[data-kc-search-input]');
	var searchClear = document.querySelector('[data-kc-search-clear]');
	var searchClose = document.querySelector('[data-kc-search-close]');
	var searchForm = document.querySelector('[data-kc-search-form]');
	var searchResults = document.querySelector('[data-kc-search-results]');
	var searchTrending = document.querySelector('[data-kc-search-trending]');
	var searchCategories = document.querySelector('[data-kc-search-categories]');
	var searchProducts = document.querySelector('[data-kc-search-products]');
	var searchViewAll = document.querySelector('[data-kc-search-view-all]');
	var searchViewAllLabel = document.querySelector('[data-kc-search-view-all-label]');
	var searchViewAllMobile = document.querySelector('[data-kc-search-view-all-mobile]');

	var searchOpen = false;

	function isDesktop() {
		return window.matchMedia('(min-width: 750px)').matches;
	}

	function openSearch(trigger) {
		if (!searchPanel) return;
		searchLastToggle = trigger || searchLastToggle;
		searchPanel.hidden = false;
		if (searchOverlay) searchOverlay.hidden = false;
		document.body.style.overflow = 'hidden';
		searchOpen = true;
		searchToggles.forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
		window.__kcSetHeaderSolid('search', true);
		announceOpen('search');
		loadLocalIndex();
		if (searchInput) searchInput.focus();
	}

	function closeSearch() {
		if (!searchPanel || !searchOpen) return;
		searchPanel.hidden = true;
		if (searchOverlay) searchOverlay.hidden = true;
		window.__kcSetHeaderSolid('search', false);
		document.body.style.overflow = '';
		searchOpen = false;
		searchToggles.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
		if (searchLastToggle) searchLastToggle.focus();
	}

	searchToggles.forEach(function (toggle) {
		toggle.addEventListener('click', function () {
			if (searchOpen) {
				closeSearch();
			} else {
				openSearch(toggle);
			}
		});
	});

	// Plain links to the search page (e.g. "Search" in the footer) open the same
	// panel as the menu button instead of the old /search page. Modified clicks
	// (new tab etc.) and links inside the panel keep their normal behaviour.
	document.addEventListener('click', function (event) {
		if (!searchPanel || event.defaultPrevented || event.button !== 0) return;
		if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
		var link = event.target.closest && event.target.closest('a[href]');
		if (!link || searchPanel.contains(link)) return;
		var url;
		try { url = new URL(link.getAttribute('href'), window.location.origin); } catch (e) { return; }
		if (url.origin !== window.location.origin || url.search) return;
		if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?search\/?$/.test(url.pathname)) return;
		event.preventDefault();
		event.stopImmediatePropagation();
		if (searchOpen) { if (searchInput) searchInput.focus(); } else { openSearch(link); }
	});

	if (searchOverlay) searchOverlay.addEventListener('click', closeSearch);
	if (searchClose) searchClose.addEventListener('click', closeSearch);

	if (searchClear) {
		searchClear.addEventListener('click', function () {
			searchInput.value = '';
			searchInput.focus();
			updateClearVisibility();
			updateResultsState();
		});
	}

	function updateClearVisibility() {
		if (!searchClear || !searchInput) return;
		searchClear.hidden = searchInput.value.length === 0;
	}

	// --- Popular search buttons ------------------------------------------------------
	document.querySelectorAll('[data-kc-search-popular]').forEach(function (button) {
		button.addEventListener('click', function () {
			searchInput.value = button.getAttribute('data-query') || button.textContent.trim();
			searchForm.submit();
		});
	});

	if (searchInput) {
		searchInput.addEventListener('input', function () {
			updateClearVisibility();
			updateResultsState();
			queuePredictiveSearch();
		});
	}

	// --- Live results (Predictive Search) ----------------------------------------------
	var searchDebounceTimer = null;
	var searchAbortController = null;

	function updateResultsState() {
		var query = searchInput ? searchInput.value.trim() : '';
		var hasQuery = query.length >= 2;
		if (searchTrending) searchTrending.hidden = hasQuery;
		if (searchResults) searchResults.hidden = !hasQuery;
	}

	function queuePredictiveSearch() {
		var query = searchInput.value.trim();
		if (searchDebounceTimer) window.clearTimeout(searchDebounceTimer);
		if (query.length < 2) return;

		searchDebounceTimer = window.setTimeout(function () {
			if (searchAbortController) searchAbortController.abort();
			searchAbortController = new AbortController();
			runPredictiveSearch(query, searchAbortController.signal);
		}, 180);
	}

	function escapeHtml(value) {
		return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
			return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
		});
	}

	// Price formatted exactly like the prices Liquid renders on the page: theme.liquid
	// outputs a sample ("1.234,56 €" etc.) in the current market's money format and
	// this copies its prefix/suffix and separators.
	function formatPrice(rawPrice) {
		var amount = parseFloat(rawPrice);
		if (isNaN(amount)) return rawPrice;
		var sample = (window.KC_I18N && KC_I18N.moneySample) || '';
		var m = sample.match(/^([^\d]*)(\d[\d.,'\s\u00a0\u202f]*\d)([^\d]*)$/);
		if (m) {
			var num = m[2];
			var dec = (num.match(/[.,](\d{2})$/) || [])[0] ? num.charAt(num.length - 3) : '';
			var body = dec ? num.slice(0, -3) : num;
			var tsep = (body.match(/[.,'\s\u00a0\u202f]/) || [''])[0];
			var fixed = amount.toFixed(dec ? 2 : 0);
			var parts = fixed.split('.');
			var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, tsep || '');
			return m[1] + whole + (dec ? dec + parts[1] : '') + m[3];
		}
		var lang = document.documentElement.lang || 'sv';
		var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK';
		try { return new Intl.NumberFormat(lang, { style: 'currency', currency: currency }).format(amount); }
		catch (e) { return amount.toFixed(2) + ' ' + currency; }
	}

	// --- Local product index (fills the gaps in Shopify's predictive search) ---------
	// Shopify's search skips many short word starts, especially in German and
	// French ("zel" does not find "Zelt"). The template collection.kc-search-index
	// lists every published product (title, url, image, price) in the current
	// language; short queries are matched against it in the browser.
	var localIndexPromise = null;
	// url path -> { d: percent, ps: sale price, po: original price } from the local index
	var saleByPath = {};

	function norm(text) {
		return String(text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
	}

	// Shopify's suggest results carry tracking params (?_pos=1&_psq=...), the local index does not
	function pathOf(url) {
		return String(url || '').split('?')[0].split('#')[0];
	}

	function loadLocalIndex() {
		if (localIndexPromise) return localIndexPromise;
		var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
		var all = [];
		function page(n) {
			return fetch(root + 'collections/all?view=kc-search-index&page=' + n)
				.then(function (r) { return r.ok ? r.text() : '[]'; })
				.then(function (text) {
					var arr = [];
					try { arr = JSON.parse(text); } catch (e) { arr = []; }
					all = all.concat(arr);
					return arr.length >= 250 && n < 8 ? page(n + 1) : all;
				});
		}
		localIndexPromise = page(1).then(function (items) {
			return items.map(function (item) {
				item.n = norm(item.t);
				if (item.d) saleByPath[pathOf(item.u)] = { d: item.d, ps: item.ps, po: item.po };
				return item;
			});
		}).catch(function () { return []; });
		return localIndexPromise;
	}

	function localMatches(index, query, exclude, max) {
		var q = norm(query).trim();
		if (!q || max <= 0) return [];
		var tokens = q.split(/\s+/);
		var scored = [];
		index.forEach(function (item) {
			if (exclude[pathOf(item.u)]) return;
			var words = item.n.split(/[^a-z0-9]+/);
			var ok = tokens.every(function (tok) {
				return words.some(function (w) { return w.indexOf(tok) === 0; }) || (tok.length >= 3 && item.n.indexOf(tok) !== -1);
			});
			if (!ok) return;
			var score = item.n.indexOf(q) === 0 ? 0 : (words.some(function (w) { return w.indexOf(q) === 0; }) ? 1 : 2);
			scored.push({ item: item, score: score });
		});
		scored.sort(function (x, y) { return x.score - y.score; });
		return scored.slice(0, max).map(function (x) {
			return { title: x.item.t, url: x.item.u, image: x.item.i, priceText: x.item.p, d: x.item.d, ps: x.item.ps, po: x.item.po };
		});
	}

	function renderCategories(collections) {
		if (!searchCategories) return;
		if (!collections.length) {
			searchCategories.innerHTML = '<p class="kc-search-results__categories-empty">' + escapeHtml(((window.KC_I18N && KC_I18N.noCategories) || 'No categories found.')) + '</p>';
			return;
		}
		searchCategories.innerHTML = collections.map(function (collection) {
			return '<a class="kc-search-results__category-row" href="' + collection.url + '">' +
				'<span>' + escapeHtml(collection.title) + '</span>' +
				'</a>';
		}).join('');
	}

	function renderProducts(products) {
		if (!searchProducts) return;
		if (!products.length) {
			searchProducts.innerHTML = '';
			return;
		}
		searchProducts.innerHTML = products.map(function (product) {
			var image = product.image
				? '<img src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy">'
				: '';
			var sale = product.d ? product : saleByPath[pathOf(product.url)];
			var badge = sale ? '<span class="kc-search-card__badge">-' + sale.d + '%</span>' : '';
			var price = sale
				? '<span class="kc-search-card__price kc-search-card__price--sale"><span class="kc-search-card__price-now">' + sale.ps + '</span><span class="kc-search-card__price-old">' + sale.po + '</span></span>'
				: '<span class="kc-search-card__price">' + (product.priceText || formatPrice(product.price)) + '</span>';
			return '<a class="kc-search-card" href="' + product.url + '">' +
				'<span class="kc-search-card__image">' + image + badge + '</span>' +
				'<span class="kc-search-card__name">' + escapeHtml(product.title) + '</span>' +
				price +
				'</a>';
		}).join('');
	}

	function updateViewAll(query, productCount) {
		var searchUrl = searchForm ? searchForm.getAttribute('action') : '/search';
		var href = searchUrl + '?q=' + encodeURIComponent(query);
		var viewAllLabel = ((window.KC_I18N && KC_I18N.viewAll) || 'VIEW ALL');
		var label = productCount > 0 ? viewAllLabel + ' (' + productCount + ')' : viewAllLabel;
		if (searchViewAll) searchViewAll.setAttribute('href', href);
		if (searchViewAllLabel) searchViewAllLabel.textContent = label;
		if (searchViewAllMobile) {
			searchViewAllMobile.textContent = label;
			searchViewAllMobile.hidden = isDesktop();
			searchViewAllMobile.onclick = function () { window.location.href = href; };
		}
	}

	function runPredictiveSearch(query, signal) {
		var url = window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(query) +
			'&resources[type]=product,collection&resources[limit]=4&resources[limit_scope]=each';

		fetch(url, { signal: signal })
			.then(function (response) { return response.json(); })
			.then(function (data) {
				var results = (data.resources && data.resources.results) || {};
				// The "Home page" collection (frontpage) is not a category worth showing.
				var collections = (results.collections || []).filter(function (collection) {
					return !/\/collections\/(frontpage|all)(\?.*)?$/.test(collection.url || '');
				});
				var products = results.products || [];
				renderCategories(collections);
				if (products.length >= 4) {
					renderProducts(products);
					updateViewAll(query, products.length);
					// the local index (loaded in the background) carries the sale labels
					loadLocalIndex().then(function () {
						if (searchInput && searchInput.value.trim() !== query) return;
						renderProducts(products);
					});
					return;
				}
				// Fewer than 4 hits from Shopify: top up from the local index.
				return loadLocalIndex().then(function (index) {
					if (searchInput && searchInput.value.trim() !== query) return;
					var seen = {};
					products.forEach(function (p) { seen[pathOf(p.url)] = true; });
					var extra = localMatches(index, query, seen, 4 - products.length);
					var merged = products.concat(extra);
					renderProducts(merged);
					updateViewAll(query, merged.length);
				});
			})
			.catch(function (error) {
				if (error && error.name === 'AbortError') return;
				if (searchCategories) searchCategories.innerHTML = '<p class="kc-search-results__categories-empty">' + escapeHtml(((window.KC_I18N && KC_I18N.searchError) || 'Something went wrong. Please try again.')) + '</p>';
				if (searchProducts) searchProducts.innerHTML = '';
			});
	}

	// --- Keyboard: Escape closes whichever panel is open ------------------------------
	document.addEventListener('keydown', function (event) {
		if (event.key !== 'Escape') return;
		if (searchOpen) closeSearch();
	});

	// --- Close on click outside --------------------------------------------------------
	document.addEventListener('click', function (event) {
		if (!searchOpen) return;
		if (searchPanel.contains(event.target)) return;
		if (searchToggles.some(function (t) { return t.contains(event.target); })) return;
		closeSearch();
	});

	// --- Currency panel(s) --------------------------------------------------------------
	// Both the header trigger and the mobile drawer's own copy share this
	// init, keyed by their own root [data-kc-currency] wrapper.
	function initCurrency(root) {
		if (root.__kcCurrencyReady) return;
		root.__kcCurrencyReady = true;

		var toggle = root.querySelector('[data-kc-currency-toggle]');
		var panel = root.querySelector('[data-kc-currency-panel]');
		var input = root.querySelector('[data-kc-currency-input]');
		var form = root.querySelector('form');
		var options = Array.prototype.slice.call(root.querySelectorAll('[data-kc-currency-option]'));
		if (!toggle || !panel) return;

		var open = false;

		function openPanel() {
			panel.hidden = false;
			toggle.classList.add('is-open');
			toggle.setAttribute('aria-expanded', 'true');
			open = true;
			announceOpen('currency');
		}

		function closePanel(focusToggle) {
			panel.hidden = true;
			toggle.classList.remove('is-open');
			toggle.setAttribute('aria-expanded', 'false');
			open = false;
			if (focusToggle) toggle.focus();
		}

		toggle.addEventListener('click', function () {
			if (open) {
				closePanel(false);
			} else {
				openPanel();
			}
		});

		var langSelect = root.querySelector('[data-kc-language-select]');
		if (langSelect && form) {
			langSelect.addEventListener('change', function () { form.submit(); });
		}

		options.forEach(function (option, index) {
			option.addEventListener('click', function () {
				if (input) input.value = option.getAttribute('data-value');
				// A new country starts in that country's own language (Germany -> German,
				// France -> French, Sweden -> Swedish, everything else English). Shopify
				// falls back to the market's default language if it isn't offered there.
				var picked = option.getAttribute('data-language') || 'en';
				if (form) {
					var langField = form.querySelector('[data-kc-language-select]') || form.querySelector('input[name="language_code"]');
					if (langField) {
						if (langField.tagName === 'SELECT') {
							langField.removeAttribute('name');
							var hidden = document.createElement('input');
							hidden.type = 'hidden';
							hidden.name = 'language_code';
							hidden.value = picked;
							form.appendChild(hidden);
						} else {
							langField.value = picked;
						}
					}
				}
				if (form) form.submit();
			});

			option.addEventListener('keydown', function (event) {
				if (event.key === 'ArrowDown') {
					event.preventDefault();
					var next = options[index + 1] || options[0];
					next.focus();
				} else if (event.key === 'ArrowUp') {
					event.preventDefault();
					var prev = options[index - 1] || options[options.length - 1];
					prev.focus();
				} else if (event.key === 'Enter') {
					event.preventDefault();
					option.click();
				}
			});
		});

		document.addEventListener('keydown', function (event) {
			if (event.key === 'Escape' && open) closePanel(true);
		});

		document.addEventListener('click', function (event) {
			if (!open) return;
			if (root.contains(event.target)) return;
			closePanel(false);
		});
	}

	document.querySelectorAll('[data-kc-currency]').forEach(initCurrency);

	// --- Close search/currency when something else announces opening -------------------
	document.addEventListener('kc:panel:opened', function (event) {
		var opener = event.detail && event.detail.name;
		if (opener !== 'search' && searchOpen) closeSearch();
		if (opener !== 'currency') {
			document.querySelectorAll('[data-kc-currency-panel]').forEach(function (panel) {
				if (!panel.hidden) {
					panel.hidden = true;
					var wrapper = panel.closest('[data-kc-currency]');
					var toggle = wrapper && wrapper.querySelector('[data-kc-currency-toggle]');
					if (toggle) {
						toggle.classList.remove('is-open');
						toggle.setAttribute('aria-expanded', 'false');
					}
				}
			});
		}
	});
})();
